import { ComponentType } from '@/shared/types';

const text = {
  component: ComponentType.Text,
  value: 'Add some text here...',
};

const input = {
  component: ComponentType.Input,
  label: 'Label',
  value: '',
  placeholder: 'Placeholder',
};

const textArea = {
  component: ComponentType.TextArea,
  label: 'Label',
  value: '',
  placeholder: 'Placeholder',
  maxLength: 1000,
};

const image = {
  component: ComponentType.Image,
  value: '',
};

const checkbox = {
  component: ComponentType.Checkbox,
  label: 'Checkbox',
  isChecked: false,
};

const video = {
  component: ComponentType.Video,
  value: '',
};

const select = {
  component: ComponentType.Select,
  value: null,
  placeholder: 'Select an option',
  options: [
    { label: 'Option 1', value: crypto.randomUUID() },
    { label: 'Option 2', value: crypto.randomUUID() },
    { label: 'Option 3', value: crypto.randomUUID() },
  ],
};

const embedding = {
  component: ComponentType.Embedding,
  value: `
<div style="max-width: 800px; margin: 20px auto; padding: 20px; background-color: #ffffff; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); border-radius: 10px;">
  <h1 style="font-size: 24px; text-align: center; margin-bottom: 20px;">Embedded Component Example</h1>
  <p style="font-family: Arial, sans-serif; line-height: 1.6; color: #333;">
    Welcome! This is a demonstration of the embedded component's capabilities using <span style="color: #007bff; font-weight: bold; text-decoration: underline;">allowed styles</span>. You can see styled blocks, text, and an iframe with a video.
  </p>

  <div style="display: flex; justify-content: center; gap: 10px; margin: 20px;">
    <div style="padding: 10px; text-align: center; font-weight: bold; color: white; border-radius: 5px; background-color: #e74c3c;">Red Box</div>
    <div style="padding: 10px; text-align: center; font-weight: bold; color: white; border-radius: 5px; background-color: #2ecc71;">Green Box</div>
    <div style="padding: 10px; text-align: center; font-weight: bold; color: white; border-radius: 5px; background-color: #3498db;">Blue Box</div>
  </div>

  <h2 style="font-size: 20px; margin-bottom: 10px;">Embedded Video</h2>
  <iframe
    src="https://www.youtube.com/embed/dQw4w9WgXcQ"
    title="Neutral Video"
    allowfullscreen
    style="border: none; width: 100%; height: 300px; border-radius: 5px; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);">
  </iframe>
</div>
`,
};

export const componentsInitialValues = {
  text,
  input,
  textArea,
  image,
  checkbox,
  video,
  select,
  embedding,
};
